import http from "@/shared/services/http";

export const createNotification = (data: any) => http.post(`v1/notifications`, data);
export const listNotification = (params: any) => http.get(`v1/notifications`, { params });
export const deleteNotification = (id: number) => http.delete(`v1/notifications/${id}`)
